import { merge } from 'rxjs/observable/merge';
import { Browser } from '../browser';

export class UserActivity {  
  
  onUserActive  
  
  constructor(browser) {
    const events = [
      'mousemove', // catches mouse movements
      'mousedown', // catches mouse movements
      'click',     // catches mouse clicks
      'wheel',     // catches wheel movements
      'scroll',    // catches scrolling
      'keypress',  // catches printable keyboard actions
      'keydown',   // catches not printable keyboard actions
      'keyup',     // catches not printable keyboard actions
      'touchmove', // catches touch actions
      'touchend'   // catches touch actions
    ];
    
    this.onUserActive = merge(
      ...browser.getEventsAsObservable(events)
    );
  }
}